import * as c from "yjs";
import { i as P, e as T } from "./collabDocumentId-DMOnFNa-.js";
import { a as b, r as A } from "./syncClientInfo-D4E7fbgz.js";
const I = !1;
class u extends Error {
  constructor() {
    super("Feedback status changed while loading. Refresh again.");
  }
}
class q {
  constructor(e, t, i) {
    this.send = e, this.ready = t, this.flush = i;
  }
  send;
  ready;
  flush;
  listing;
  retryWait;
  refreshTimer;
  refreshing = !1;
  mutations = 0;
  refreshAgain = !1;
  epoch = 0;
  connection = 0;
  sequence = 0;
  applied = 0;
  state = [];
  authority = { loaded: !1 };
  listeners = /* @__PURE__ */ new Set();
  pending = /* @__PURE__ */ new Map();
  getState = () => this.state;
  subscribe = (e) => (this.listeners.add(e), e(this.state, this.authority), () => {
    this.listeners.delete(e);
  });
  publish() {
    for (const e of this.listeners) e(this.state, this.authority);
  }
  clear() {
    this.epoch++, this.state = [], this.authority = { loaded: !1 }, this.publish();
  }
  hasPendingMutations = () => this.mutations > 0;
  request(e) {
    if (e.operation === "list") {
      if (this.listing) return this.listing;
      const t = this.connection, i = this.requestFreshList().catch((s) => {
        throw t === this.connection && (this.refreshAgain = !1, this.refreshTimer && clearTimeout(this.refreshTimer), this.refreshTimer = void 0), s;
      }).finally(() => {
        this.listing === i && (this.listing = void 0);
      });
      return this.listing = i, i;
    }
    return this.mutations++, this.requestCommand(e).finally(() => {
      this.mutations--;
    });
  }
  async requestFreshList() {
    const e = this.connection;
    for (let t = 0; t < 4; t++) {
      if (e !== this.connection)
        throw new Error("Document disconnected while refreshing feedback.");
      if (t > 0) {
        const s = this.epoch;
        if (await new Promise((n, a) => {
          const r = setTimeout(() => {
            this.retryWait = void 0, n();
          }, 10);
          this.retryWait = { timer: r, reject: a };
        }), e !== this.connection)
          throw new Error("Document disconnected while refreshing feedback.");
        if (s !== this.epoch) continue;
      }
      this.refreshAgain = !1, this.refreshTimer && clearTimeout(this.refreshTimer), this.refreshTimer = void 0;
      const i = this.epoch;
      try {
        const s = this.requestCommand({ operation: "list" }), n = this.sequence, a = await s;
        if (e !== this.connection)
          throw new Error("Document disconnected while refreshing feedback.");
        if (!a.loaded)
          return this.refreshAgain = !1, this.refreshTimer && clearTimeout(this.refreshTimer), this.refreshTimer = void 0, a;
        if (i !== this.epoch || n < this.applied)
          throw new u();
        return a;
      } catch (s) {
        if (!(s instanceof u)) throw s;
      }
    }
    throw new u();
  }
  async requestCommand(e) {
    const t = this.connection;
    try {
      if (!this.ready())
        throw new Error(
          "Wait for this document to connect before sending feedback."
        );
      if (e.operation !== "list" && !await this.flush())
        throw new Error(
          "The document has not been saved to the server. Retry after it reconnects."
        );
      if (t !== this.connection || !this.ready())
        throw new Error("Document disconnected before the request was sent.");
    } catch (a) {
      throw t === this.connection && this.clear(), a;
    }
    const i = crypto.randomUUID(), s = this.epoch, n = ++this.sequence;
    return new Promise((a, r) => {
      const d = (l) => {
        this.pending.delete(i), s === this.epoch && n >= this.applied && this.clear(), r(l);
      }, p = setTimeout(
        () => d(
          new Error(
            "Feedback delivery could not be confirmed. Reconnect and retry; the same block will not be sent twice."
          )
        ),
        15e3
      );
      this.pending.set(i, {
        resolve: a,
        reject: r,
        timer: p,
        epoch: s,
        sequence: n,
        operation: e.operation
      });
      try {
        this.send({ type: "docDecisionCommand", requestId: i, command: e });
      } catch (l) {
        clearTimeout(p), d(l instanceof Error ? l : new Error(String(l)));
      }
    });
  }
  receive(e) {
    const t = e.requestId ? this.pending.get(e.requestId) : void 0;
    if (!t) return;
    if (clearTimeout(t.timer), this.pending.delete(e.requestId), t.epoch !== this.epoch || t.sequence < this.applied) {
      e.error ? t.reject(new Error(e.error)) : t.operation === "list" && e.privacyVersion === 1 ? t.reject(new u()) : t.resolve({ decisions: [], loaded: !1 });
      return;
    }
    if (this.applied = t.sequence, e.error) {
      this.clear(), t.reject(new Error(e.error));
      return;
    }
    const i = e.privacyVersion === 1, s = i && (t.operation === "list" || this.authority.loaded);
    this.authority = {
      loaded: s,
      ...i ? { privacyVersion: 1 } : {}
    }, this.state = s ? e.decisions : [], this.publish(), t.resolve({ decisions: this.state, ...this.authority });
  }
  refreshSubscribers() {
    this.listeners.size && this.invalidate();
  }
  /** Clear synchronously; fetch only each connection's authorized projection. */
  invalidate() {
    this.clear(), this.refreshAgain = !0, this.scheduleRefresh();
  }
  scheduleRefresh() {
    this.refreshTimer || this.refreshing || !this.ready() || (this.refreshTimer = setTimeout(() => {
      this.refreshTimer = void 0, this.refreshAgain = !1, this.refreshing = !0;
      const e = this.connection;
      this.request({ operation: "list" }).catch(() => {
        e === this.connection && (this.refreshAgain = !1);
      }).finally(() => {
        e === this.connection && (this.refreshing = !1, this.refreshAgain && this.scheduleRefresh());
      });
    }, 10));
  }
  disconnect() {
    this.connection++, this.listing = void 0, this.retryWait && (clearTimeout(this.retryWait.timer), this.retryWait.reject(
      new Error("Document disconnected while refreshing feedback.")
    ), this.retryWait = void 0), this.refreshTimer && clearTimeout(this.refreshTimer), this.refreshTimer = void 0, this.refreshing = !1, this.refreshAgain = !1, this.clear();
    for (const e of this.pending.values())
      clearTimeout(e.timer), e.reject(
        new Error(
          "Document disconnected before feedback delivery was confirmed."
        )
      );
    this.pending.clear();
  }
}
function R(o) {
  return o.teamMemberId ?? o.personalMemberId;
}
const k = /* @__PURE__ */ new Set([
  "forbidden",
  "membership_revoked",
  "authorization_revoked",
  "access_revoked",
  "not_a_member",
  "document_access_revoked",
  // A role that permits reading but not editing is a settled answer, not a
  // transient one: retrying replays the same refused update on every
  // reconnect, forever, instead of telling the user the document is read-only.
  "document_read_only"
]);
function D(o) {
  return k.has(o);
}
const y = 8192;
function g(o) {
  if (o.length < 1024)
    return btoa(String.fromCharCode(...o));
  let e = "";
  for (let t = 0; t < o.length; t += y) {
    const i = o.subarray(t, Math.min(t + y, o.length));
    e += String.fromCharCode(...i);
  }
  return btoa(e);
}
function m(o) {
  const e = atob(o), t = new ArrayBuffer(e.length), i = new Uint8Array(t);
  for (let s = 0; s < e.length; s++)
    i[s] = e.charCodeAt(s);
  return i;
}
const f = "remote", w = "snapshot", S = "persistedPending", U = 500, C = 3e4, E = 200, O = 300 * 1e3, v = 20, W = 60 * 1e3;
class h {
  ydoc;
  ownsYDoc;
  ws = null;
  config;
  memberId;
  status = "disconnected";
  lastSeq = 0;
  lastSyncRequestSeq = 0;
  serverCapability = "unknown";
  cursorLagRecordedForConnection = !1;
  synced = !1;
  // Last-writer attribution from the server (who/when last edited the content).
  // Populated from docSyncResponse; used by the overwrite confirm before a push.
  lastWriterUserId = null;
  lastUpdatedAt = null;
  updateObserverDispose = null;
  awarenessStates = /* @__PURE__ */ new Map();
  awarenessTimestamps = /* @__PURE__ */ new Map();
  awarenessListeners = /* @__PURE__ */ new Set();
  statusListeners = /* @__PURE__ */ new Set();
  destroyed = !1;
  // Throttled awareness state
  pendingAwareness = null;
  awarenessThrottleTimer = null;
  lastAwarenessSendTime = 0;
  awarenessCleanupTimer = null;
  // Reconnect state
  reconnectAttempt = 0;
  reconnectTimer = null;
  suppressReconnect = !1;
  /**
   * NIM-949: set when the server rejected the ws upgrade with an auth-style
   * status (proxy forwards a close reason of `auth-rejected:<status>`). The next
   * connect() then requests a freshly-exchanged JWT instead of replaying the
   * cached (wrong-org / expired) token that just got rejected.
   */
  forceJwtRefreshNextConnect = !1;
  /**
   * Upgrade-rejection status from the most recent close, or null if the last
   * close wasn't an auth rejection.
   *
   * Lets a caller that connects for one bounded operation (the headless seed)
   * distinguish "the server refused this room" from "still connecting" instead
   * of polling `getStatus()` until its timeout expires. A 404 here means the
   * document id is not in the org's index yet (NIM-2472).
   */
  lastAuthRejectionStatus = null;
  queuedPendingUpdate = null;
  inflightPendingUpdate = null;
  pendingPersistTimer = null;
  replayAckTimer = null;
  replayingClientUpdateId = null;
  replayingReplicaOutboxIds = [];
  replayStartedAt = null;
  replayAttemptCount = 0;
  surfaceReplayStatus = !1;
  pendingWriteWaiters = /* @__PURE__ */ new Set();
  static RECONNECT_BASE_MS = 1e3;
  static RECONNECT_MAX_MS = 3e4;
  static REPLAY_ACK_TIMEOUT_MS = 1e4;
  // Compaction state
  /**
   * Server sequence covered by the latest snapshot we know about. Updated
   * when (a) we apply a server snapshot during sync, and (b) the server
   * acknowledges our own `docCompact`. Used to compute how many updates have
   * accumulated.
   */
  lastSnapshotSeq = 0;
  pendingCompactionId = null;
  compactionAckTimer = null;
  static COMPACTION_ACK_TIMEOUT_MS = 1e4;
  /**
   * Resolver for an in-flight `forceReplaceServerState` awaiting its
   * `docCompactAck`. Distinct from routine compaction (which is fire-and-forget)
   * because the recovery caller must know whether the server accepted the
   * replacement snapshot.
   */
  forceReplaceWaiter = null;
  forceReplaceCounter = 0;
  /**
   * True once ANY snapshot/update/broadcast failed to decode and was skipped
   * (the NIM-878 tolerant-skip). `lastSeq` still advances past skipped rows, so
   * this doc is missing server content it can never re-fetch on this provider
   * (resync resumes from `lastSeq`). While set, this client must NEVER win
   * compaction: a `docCompact` of an incomplete doc buries the unread rows
   * behind `replacesUpTo` for every client and prune later deletes them
   * (NIM-1519). Deliberately never reset for the provider's lifetime.
   *
   * The trigger is "content we do not hold", NOT "something threw while
   * applying". A Y.Doc listener that throws AFTER `Y.applyUpdate` integrated
   * the update (an editor binding hitting an unregistered node type, say) does
   * not set this flag: yjs commits the transaction and then calls observers via
   * `lib0/function.callAll`, which runs every listener and rethrows at the end,
   * so the CRDT already holds the full update. Vetoing compaction there would
   * degrade a whole room's sync on the strength of a client-side rendering bug.
   * See `applyDecodedUpdate` for how the two are told apart.
   */
  skippedUndecodablePayload = !1;
  lastCompactionAttemptAt = 0;
  compactionTimer = null;
  constructor(e) {
    if (this.config = e, this.memberId = R(e), this.ydoc = e.replica?.getYDoc() ?? e.ydoc ?? new c.Doc(), this.ownsYDoc = !e.replica && !e.ydoc, this.setupUpdateObserver(), e.initialPendingUpdateBase64)
      try {
        this.queuedPendingUpdate = m(e.initialPendingUpdateBase64), c.applyUpdate(
          this.ydoc,
          this.queuedPendingUpdate,
          S
        ), this.setStatus("offline-unsynced");
      } catch (t) {
        console.error("[DocumentSync] Failed to restore pending local update:", t), this.queuedPendingUpdate = null;
      }
    e.replica && e.replica.whenReady.then(() => {
      if (this.destroyed) return;
      const t = e.replica?.getPendingOutboxUpdate();
      t && (this.queuedPendingUpdate = this.queuedPendingUpdate ? c.mergeUpdates([this.queuedPendingUpdate, t]) : t, this.setStatus("offline-unsynced"));
    });
  }
  // --------------------------------------------------------------------------
  // Lifecycle
  // --------------------------------------------------------------------------
  /**
   * Connect to the DocumentRoom and begin syncing.
   */
  connecting = !1;
  async connect() {
    if (this.destroyed || this.ws || this.connecting)
      return;
    if (this.suppressReconnect = !1, this.connecting = !0, this.setStatus("connecting"), this.config.replica) {
      if (await this.config.replica.whenReady, this.destroyed) {
        this.connecting = !1;
        return;
      }
      if (this.config.replica.needsCleanServerHydration())
        try {
          await this.config.replica.beginCleanServerHydration(), this.skippedUndecodablePayload = !1;
        } catch (r) {
          console.warn("[DocumentSync] Failed to prepare damaged replica for clean hydration:", r);
        }
      this.lastSeq = this.config.replica.getLastServerSeq(), this.queuedPendingUpdate = this.config.replica.getPendingOutboxUpdate() ?? this.queuedPendingUpdate;
    }
    const { serverUrl: e, orgId: t, documentId: i } = this.config;
    P(i) || console.warn(
      `[DocumentSync] documentId ${JSON.stringify(i)} is not a plain URL-safe id (likely a legacy filename); connecting with it URL-encoded.`
    );
    const s = T(t, i);
    let n;
    try {
      if (this.config.buildUrl)
        n = this.config.buildUrl(s);
      else {
        const r = this.forceJwtRefreshNextConnect;
        this.forceJwtRefreshNextConnect = !1;
        const d = await this.config.getJwt(r ? { forceRefresh: !0 } : void 0);
        n = b(`${e}/sync/${s}?token=${encodeURIComponent(d)}`);
      }
    } catch (r) {
      console.error("[DocumentSync] Failed to build URL:", r), this.connecting = !1, this.setStatus(this.hasPendingLocalUpdates() ? "offline-unsynced" : "disconnected"), this.scheduleReconnect();
      return;
    }
    if (this.destroyed || this.ws) {
      this.connecting = !1;
      return;
    }
    console.log("[DocumentSync] Connecting to:", A(n));
    const a = this.config.createWebSocket ? this.config.createWebSocket(n) : new WebSocket(n);
    this.ws = a, this.connecting = !1, a.addEventListener("open", () => {
      this.ws === a && (console.log("[DocumentSync] WebSocket open"), this.suppressReconnect = !1, this.reconnectAttempt = 0, this.setStatus("syncing"), this.startAwarenessCleanup(), this.requestSync());
    }), a.addEventListener("message", (r) => {
      this.ws === a && this.handleMessage(r);
    }), a.addEventListener("close", (r) => {
      if (this.ws === a) {
        if (console.log("[DocumentSync] WebSocket closed, code:", r.code, "reason:", r.reason), typeof r.reason == "string" && r.reason.startsWith("auth-rejected")) {
          this.forceJwtRefreshNextConnect = !0;
          const d = Number.parseInt(r.reason.split(":")[1] ?? "", 10);
          this.lastAuthRejectionStatus = Number.isFinite(d) ? d : 0;
        }
        this.handleDisconnect();
      }
    }), a.addEventListener("error", (r) => {
      this.ws === a && (console.error("[DocumentSync] WebSocket error:", r), this.handleDisconnect());
    });
  }
  /**
   * Disconnect from the DocumentRoom.
   */
  disconnect() {
    if (this.decisionClient.disconnect(), this.cancelReconnect(), this.clearReplayAckTimer(), this.clearCompactionAckTimer(), this.pendingCompactionId = null, this.forceReplaceWaiter) {
      const e = this.forceReplaceWaiter;
      this.forceReplaceWaiter = null, e.resolve(!1);
    }
    this.connecting = !1, this.suppressReconnect = !0, this.requeueInflightPendingUpdate(), this.stopAwarenessCleanup(), this.clearAwarenessThrottle(), this.stopCompactionTimer(), this.ws && (this.ws.close(), this.ws = null), this.synced = !1, this.setStatus(
      this.hasPendingLocalUpdates() ? "offline-unsynced" : "disconnected"
    );
  }
  /** Destroy this network attachment. Externally supplied Y.Docs survive. */
  destroy() {
    this.destroyed = !0, this.disconnect(), this.teardownUpdateObserver(), this.flushPendingPersistImmediately(), this.ownsYDoc && this.ydoc.destroy(), this.awarenessListeners.clear(), this.awarenessStates.clear(), this.statusListeners.clear();
  }
  // --------------------------------------------------------------------------
  // Public API
  // --------------------------------------------------------------------------
  /** Get the Y.Doc managed by this provider. */
  getYDoc() {
    return this.ydoc;
  }
  /**
   * The room-authenticated member id of whoever last applied a content update, or null if
   * the doc has no updates yet / the server hasn't reported it. Populated from
   * the server's docSyncResponse. Reflects the last *content* edit.
   */
  getLastWriterUserId() {
    return this.lastWriterUserId;
  }
  /** When the last content update was applied (server clock, ms), or null. */
  getLastUpdatedAt() {
    return this.lastUpdatedAt;
  }
  /** Check if connected and synced. */
  isConnected() {
    return this.status === "connected";
  }
  /** Check if initial sync is complete. */
  isSynced() {
    return this.synced;
  }
  /** Get current connection status. */
  getStatus() {
    return this.status;
  }
  /**
   * HTTP status of the most recent upgrade rejection, or null when the last
   * close wasn't one. 404 means the server does not consider this document to
   * exist for this user -- for a freshly created document, that its index row
   * has not landed yet (NIM-2472).
   */
  getLastAuthRejectionStatus() {
    return this.lastAuthRejectionStatus;
  }
  /** Get the last known server sequence number. */
  getLastSeq() {
    return this.lastSeq;
  }
  /**
   * True when any snapshot/update/broadcast was skipped as undecodable this
   * provider's lifetime. While true, the Y.Doc looking "empty" does NOT mean
   * the room is empty — server content exists that this client cannot read.
   * Hosts must gate first-open seeding on this (seeding a default document
   * over unreadable-but-real content clobbers it for every client) and this
   * provider will never compact (NIM-1519).
   */
  hasUndecodedContent() {
    return this.skippedUndecodablePayload;
  }
  /**
   * Wait until all local writes have either been acknowledged or timed out.
   * Returns false when the timeout elapses first.
   */
  async waitForPendingWrites(e = 5e3) {
    return this.hasUnsettledPendingWrites() ? new Promise((t) => {
      let i = !1;
      const s = () => {
        this.pendingWriteWaiters.delete(n), clearTimeout(a);
      }, n = () => {
        i || this.hasUnsettledPendingWrites() || (i = !0, s(), t(!0));
      }, a = setTimeout(() => {
        i || (i = !0, s(), t(!1));
      }, e);
      this.pendingWriteWaiters.add(n), n();
    }) : !0;
  }
  /** Synchronous close guard; only a server acknowledgement clears unsettled writes. */
  hasPendingWrites() {
    return this.hasUnsettledPendingWrites() || this.decisionClient.hasPendingMutations();
  }
  /**
   * Set room-level metadata on the server (e.g., custom TTL).
   * Only allowlisted keys are accepted server-side.
   */
  setRoomMetadata(e) {
    this.send({ type: "docSetMetadata", entries: e });
  }
  /**
   * Encode bytes for the wire: pass-through (base64 raw bytes, empty-string iv
   * sentinel). The server encrypts at rest with the team DEK; the client holds
   * no team key.
   */
  async encodeForWire(e) {
    return { encrypted: g(e), iv: "" };
  }
  /**
   * Decode bytes from the wire.
   *
   * The server decrypts rows it owns and sends them as PLAINTEXT with the
   * empty-iv sentinel (''). A NON-EMPTY iv means the row is pre-cutover
   * ciphertext from the retired client-managed lane: no supported client holds
   * the key for it, so throw rather than hand Yjs bytes that decode to garbage.
   * The per-payload catch skips just that row instead of blanking the document.
   */
  async decodeFromWire(e, t) {
    if (t)
      throw new Error(
        "Document row is pre-cutover client-encrypted content and can no longer be read"
      );
    return m(e);
  }
  sendAwarenessImmediately(e) {
    if (!this.ws || this.ws.readyState !== WebSocket.OPEN) return !1;
    const t = new TextEncoder().encode(JSON.stringify(e));
    return this.send({
      type: "docAwareness",
      encryptedState: g(t),
      iv: ""
    }), !0;
  }
  /**
   * Send awareness state to other connected clients. Awareness is plaintext
   * over TLS now that team custody is server-managed; the empty-iv sentinel
   * keeps the wire shape unchanged.
   * Sends immediately (no throttling). Use setLocalAwareness() for throttled updates.
   */
  async sendAwareness(e) {
    this.sendAwarenessImmediately(e);
  }
  /**
   * Synchronously put an additive departure marker on the open socket.
   *
   * This deliberately bypasses both the 500ms awareness throttle and the
   * async encodeForWire seam: awareness is already plaintext-over-TLS with
   * an empty IV. Teardown can therefore send this frame before closing the
   * socket, including from pagehide where awaiting is unreliable.
   */
  sendAwarenessDeparture(e) {
    return this.clearAwarenessThrottle(), this.sendAwarenessImmediately({
      user: { ...e },
      nimbalystDeparture: { version: 1 }
    });
  }
  /**
   * Set local awareness state with throttling (~2Hz).
   * Coalesces rapid updates (e.g., cursor movements while typing) and sends
   * at most once per AWARENESS_THROTTLE_MS.
   */
  setLocalAwareness(e) {
    this.pendingAwareness = e;
    const i = Date.now() - this.lastAwarenessSendTime;
    if (i >= U)
      this.flushAwareness();
    else if (!this.awarenessThrottleTimer) {
      const s = U - i;
      this.awarenessThrottleTimer = setTimeout(() => {
        this.awarenessThrottleTimer = null, this.flushAwareness();
      }, s);
    }
  }
  flushAwareness() {
    if (!this.pendingAwareness) return;
    const e = this.pendingAwareness;
    this.pendingAwareness = null, this.lastAwarenessSendTime = Date.now(), this.sendAwareness(e);
  }
  clearAwarenessThrottle() {
    this.awarenessThrottleTimer && (clearTimeout(this.awarenessThrottleTimer), this.awarenessThrottleTimer = null), this.pendingAwareness = null;
  }
  /**
   * Subscribe to awareness state changes from remote users.
   * Returns an unsubscribe function.
   */
  onAwarenessChange(e) {
    return this.awarenessListeners.add(e), () => this.awarenessListeners.delete(e);
  }
  /**
   * Get current awareness states for all remote users.
   */
  getAwarenessStates() {
    return new Map(this.awarenessStates);
  }
  /**
   * Subscribe to transport status changes. Returns an unsubscribe function.
   *
   * `DocumentSyncConfig.onStatusChange` is a single slot owned by whichever
   * host constructed the provider. This is the multi-listener seam for things
   * that attach to an already-built provider -- the extension awareness bridge
   * needs it to re-announce presence when a reconnect completes.
   */
  onStatusChange(e) {
    return this.statusListeners.add(e), () => this.statusListeners.delete(e);
  }
  /**
   * Force the provider to treat the current Y.Doc as local state that should
   * be persisted upstream.
   *
   * Used by custom-editor collaboration bootstrap after a first-open seed from
   * in-memory share payloads. This avoids depending on observer/replay timing
   * when the seed happens after the initial empty sync completes.
   *
   * @deprecated Fire-and-forget: this resolves after the socket write, NOT
   * after the server confirms persistence, so a teardown immediately after can
   * lose the seed (the mindmap seed data-loss race). Prefer {@link flushWithAck},
   * which awaits a server-persisted `docUpdateAck`.
   */
  async flushLocalState() {
    const e = c.encodeStateAsUpdate(this.ydoc);
    e.length <= 2 || (this.enqueuePendingLocalUpdate(e), this.ws && this.ws.readyState === WebSocket.OPEN && this.synced && await this.replayPendingUpdate());
  }
  /**
   * Flush the current Y.Doc state upstream and resolve ONLY after the server
   * acknowledges persistence (`docUpdateAck`), not merely after the socket
   * write. This is the durability guarantee for first-open seeds and headless
   * re-uploads: content the user sees locally must reach the server before the
   * provider tears down.
   *
   * Returns `true` when the server ack'd within `timeoutMs`, `false` on timeout
   * or when not connected/synced — the caller decides whether to warn / retry
   * rather than silently discarding the seed. An empty doc (encoded state
   * <= 2 bytes) resolves `true` immediately (nothing to persist).
   *
   * The server-ack semantics come from `waitForPendingWrites`, which settles
   * only once the inflight `docUpdate` is cleared by a matching `docUpdateAck`
   * (the DocumentRoom persists synchronously to DO storage before acking).
   */
  async flushWithAck(e = 5e3) {
    const t = c.encodeStateAsUpdate(this.ydoc);
    return t.length <= 2 ? !0 : (this.enqueuePendingLocalUpdate(t), this.ws && this.ws.readyState === WebSocket.OPEN && this.synced && await this.replayPendingUpdate(), this.waitForPendingWrites(e));
  }
  // --------------------------------------------------------------------------
  // Sync Protocol
  // --------------------------------------------------------------------------
  decisionClient = new q(
    (e) => this.send(e),
    () => this.isSynced(),
    () => this.flushWithAck(8e3)
  );
  requestDecision(e) {
    return this.decisionClient.request(e);
  }
  getDecisionState = () => this.decisionClient.getState();
  onDecisionState = (e) => this.decisionClient.subscribe(e);
  requestSync() {
    this.lastSyncRequestSeq = this.lastSeq, this.send({ type: "docSyncRequest", sinceSeq: this.lastSeq });
  }
  async handleMessage(e) {
    try {
      const t = typeof e.data == "string" ? e.data : new TextDecoder().decode(e.data), i = JSON.parse(t);
      switch (i.type) {
        case "docDecisionChanged":
          this.decisionClient.invalidate();
          break;
        case "docDecisionState":
          this.decisionClient.receive(i);
          break;
        case "docSyncResponse":
          await this.handleSyncResponse(i), i.hasMore || this.decisionClient.refreshSubscribers();
          break;
        case "docUpdateBroadcast":
          await this.handleUpdateBroadcast(i);
          break;
        case "docUpdateAck":
          await this.handleUpdateAck(i);
          break;
        case "docCompactAck":
          this.handleCompactionAck(i);
          break;
        case "docAwarenessBroadcast":
          await this.handleAwarenessBroadcast(i);
          break;
        case "docRoomMoved":
          this.disconnect(), this.config.onRoomMoved?.({ destOrgId: i.destOrgId });
          break;
        case "error":
          console.error("[DocumentSync] Server error:", i.code, i.message), await this.handleWriteRejection(i.code, i.clientUpdateId);
          break;
      }
    } catch (t) {
      if (console.error("[DocumentSync] Error handling message:", t), t instanceof DOMException && t.name === "OperationError") {
        console.warn("[DocumentSync] Uncaught OperationError at handleMessage scope -- dropping message.");
        return;
      }
    }
  }
  /**
   * Apply already-decrypted bytes to the Y.Doc, separating the two very
   * different ways `Y.applyUpdate` can throw:
   *
   *  - `integrated: false` -- the bytes could not be read/integrated. The
   *    payload is bad and the Y.Doc may hold only part of it.
   *  - `integrated: true` -- the update was fully integrated into the CRDT and
   *    then a Y.Doc *listener* threw (e.g. an editor binding hitting an
   *    unregistered node type). The document content is complete; the failure
   *    is downstream of sync.
   *
   * The discriminator is exact rather than heuristic. `Y.applyUpdate` opens its
   * own transaction; nesting it inside one of ours makes the inner call a no-op
   * nest (yjs reuses the open transaction), so observers fire only when the
   * OUTER transaction unwinds. `integrated` is therefore set if and only if
   * `readUpdate` completed, before any observer has run. `local: false` matches
   * what `applyUpdate` sets on the transaction itself.
   */
  applyDecodedUpdate(e, t) {
    let i = !1;
    try {
      return c.transact(
        this.ydoc,
        () => {
          c.applyUpdate(this.ydoc, e, t), i = !0;
        },
        t,
        !1
      ), { ok: !0 };
    } catch (s) {
      return { ok: !1, integrated: i, error: s };
    }
  }
  /** Matches the shape the existing skip logs pass as their second argument. */
  static logDetail(e) {
    return e instanceof Error ? e.message : e;
  }
  async handleSyncResponse(e) {
    if (typeof e.serverHead == "number" && typeof e.serverHasState == "boolean")
      this.serverCapability = "explicit-head", this.cursorLagRecordedForConnection || (this.cursorLagRecordedForConnection = !0, this.config.onOfflineMetric?.({
        metric: "cursor_lag_at_reconnect",
        cursorLag: Math.max(0, e.serverHead - this.lastSyncRequestSeq)
      }));
    else if (this.serverCapability !== "legacy" && (this.serverCapability = "legacy", this.lastSyncRequestSeq !== 0)) {
      this.lastSeq = 0, this.requestSync();
      return;
    }
    e.lastWriterUserId !== void 0 && (this.lastWriterUserId = e.lastWriterUserId), e.lastUpdatedAt !== void 0 && (this.lastUpdatedAt = e.lastUpdatedAt);
    const i = [];
    let s = !0;
    if (e.snapshot) {
      let n = null;
      try {
        n = await this.decodeFromWire(
          e.snapshot.encryptedState,
          e.snapshot.iv
        );
      } catch (a) {
        console.warn("[DocumentSync] Skipping undecodable snapshot; sync will continue:", h.logDetail(a)), this.skippedUndecodablePayload = !0, s = !1;
      }
      if (n !== null)
        if (this.config.replica)
          i.push({
            update: n,
            source: "server-snapshot",
            // Snapshots cover a sequence but are not themselves an update at
            // that sequence. Keeping this null avoids collision-drops against
            // an already persisted broadcast row.
            serverSequence: null
          });
        else {
          const a = this.applyDecodedUpdate(n, w);
          !a.ok && !a.integrated ? (console.warn("[DocumentSync] Skipping snapshot that decrypted but could not be integrated; sync will continue:", h.logDetail(a.error)), this.skippedUndecodablePayload = !0, s = !1) : a.ok || (console.error("[DocumentSync] Snapshot applied, but a Y.Doc listener threw while handling it (editor/binding failure, not a bad payload):", a.error), this.config.onEditorBindingError?.(a.error));
        }
      this.lastSeq = Math.max(this.lastSeq, e.snapshot.replacesUpTo), this.lastSnapshotSeq = Math.max(this.lastSnapshotSeq, e.snapshot.replacesUpTo);
    }
    for (const n of e.updates) {
      let a = null;
      try {
        a = await this.decodeFromWire(
          n.encryptedUpdate,
          n.iv
        );
      } catch (r) {
        console.warn(`[DocumentSync] Skipping undecodable update at seq ${n.sequence}:`, h.logDetail(r)), this.skippedUndecodablePayload = !0, s = !1;
      }
      if (a !== null)
        if (this.config.replica)
          i.push({
            update: a,
            source: "remote",
            serverSequence: n.sequence
          });
        else {
          const r = this.applyDecodedUpdate(a, f);
          !r.ok && !r.integrated ? (console.warn(`[DocumentSync] Skipping update at seq ${n.sequence} that decrypted but could not be integrated:`, h.logDetail(r.error)), this.skippedUndecodablePayload = !0, s = !1) : r.ok || (console.error(`[DocumentSync] Update at seq ${n.sequence} applied, but a Y.Doc listener threw while handling it (editor/binding failure, not a bad payload):`, r.error), this.config.onEditorBindingError?.(r.error));
        }
      this.lastSeq = Math.max(this.lastSeq, n.sequence);
    }
    if (this.config.replica)
      try {
        const n = s && !e.hasMore && this.serverCapability === "explicit-head" ? e.serverHead : e.cursor;
        await this.config.replica.applyRemoteUpdates(
          i,
          s ? n : this.config.replica.getLastServerSeq()
        ) || (s = !1, this.skippedUndecodablePayload = !0), !s && this.config.replica.isComplete() && await this.config.replica.markIncomplete();
      } catch (n) {
        console.warn("[DocumentSync] Failed to apply/persist validated remote batch:", n), this.skippedUndecodablePayload = !0, await this.config.replica.markIncomplete();
      }
    if (e.hasMore) {
      this.lastSeq = e.cursor, this.requestSync();
      return;
    }
    this.synced || (await this.config.replica?.completeCleanServerHydration(
      !this.skippedUndecodablePayload
    ), this.synced = !0, this.serverCapability === "explicit-head" && (this.lastSeq = Math.max(this.lastSeq, e.serverHead)), this.config.onFirstSyncComplete?.(e.serverHasState === !1), this.notifyContentChanged(), this.hasPendingLocalUpdates() ? await this.replayPendingUpdate() : (this.setStatus("connected"), await this.pushLocalState(e)), this.startCompactionTimer());
  }
  async handleUpdateBroadcast(e) {
    let t;
    try {
      if (t = await this.decodeFromWire(
        e.encryptedUpdate,
        e.iv
      ), this.config.replica) {
        if (!await this.config.replica.applyRemoteUpdates(
          [{ update: t, source: "remote", serverSequence: e.sequence }],
          // A broadcast sequence does not prove contiguous coverage below it.
          // The next sync response persists an authoritative page cursor.
          this.config.replica.getLastServerSeq(),
          { coalescePersistence: !0 }
        )) {
          this.skippedUndecodablePayload = !0, this.ws && this.ws.readyState === WebSocket.OPEN && this.ws.close();
          return;
        }
      } else {
        const s = this.applyDecodedUpdate(t, f);
        if (!s.ok && !s.integrated)
          throw s.error;
        s.ok || (console.error(`[DocumentSync] Broadcast at seq ${e.sequence} applied, but a Y.Doc listener threw while handling it (editor/binding failure, not a bad payload):`, s.error), this.config.onEditorBindingError?.(s.error));
      }
    } catch (s) {
      if (console.warn(`[DocumentSync] Skipping undecodable or unpersisted broadcast at seq ${e.sequence}:`, h.logDetail(s)), this.skippedUndecodablePayload = !0, this.config.replica)
        try {
          await this.config.replica.markIncomplete();
        } catch {
        }
      this.ws && this.ws.readyState === WebSocket.OPEN && this.ws.close(), this.lastSeq = Math.max(this.lastSeq, e.sequence);
      return;
    }
    this.lastSeq = Math.max(this.lastSeq, e.sequence), this.config.onRemoteUpdate?.(f), this.notifyContentChanged();
  }
  async handleAwarenessBroadcast(e) {
    if (e.fromUserId !== this.memberId)
      try {
        const t = await this.decodeFromWire(
          e.encryptedState,
          e.iv
        ), i = JSON.parse(
          new TextDecoder().decode(t)
        );
        i.nimbalystDeparture?.version === 1 ? (this.awarenessStates.delete(e.fromUserId), this.awarenessTimestamps.delete(e.fromUserId)) : (this.awarenessStates.set(e.fromUserId, i), this.awarenessTimestamps.set(e.fromUserId, Date.now())), this.notifyAwarenessListeners();
      } catch (t) {
        console.error("[DocumentSync] Failed to decrypt awareness:", t);
      }
  }
  // --------------------------------------------------------------------------
  // Local Update Observation
  // --------------------------------------------------------------------------
  /**
   * Watch the Y.Doc for local updates and send them to the server.
   */
  setupUpdateObserver() {
    if (this.updateObserverDispose) return;
    const e = async (t, i) => {
      if (!(this.config.replica?.isInternalOrigin(i) || i === f || i === w || i === S)) {
        try {
          this.config.onLocalUpdate?.();
        } catch (s) {
          console.warn("[DocumentSync] onLocalUpdate callback failed:", s);
        }
        this.notifyContentChanged(), this.enqueuePendingLocalUpdate(t), this.ws && this.ws.readyState === WebSocket.OPEN && this.synced && await this.replayPendingUpdate();
      }
    };
    this.ydoc.on("update", e), this.updateObserverDispose = () => this.ydoc.off("update", e);
  }
  teardownUpdateObserver() {
    this.updateObserverDispose?.(), this.updateObserverDispose = null;
  }
  notifyContentChanged() {
    if (!this.skippedUndecodablePayload)
      try {
        this.config.onContentChanged?.(this.ydoc);
      } catch (e) {
        console.warn("[DocumentSync] Content-change callback failed:", e);
      }
  }
  // --------------------------------------------------------------------------
  // Helpers
  // --------------------------------------------------------------------------
  send(e) {
    this.ws && this.ws.readyState === WebSocket.OPEN && this.ws.send(JSON.stringify(e));
  }
  getRoomId() {
    return `org:${this.config.orgId}:doc:${this.config.documentId}`;
  }
  enqueuePendingLocalUpdate(e) {
    this.queuedPendingUpdate = this.queuedPendingUpdate ? c.mergeUpdates([this.queuedPendingUpdate, e]) : e.slice(), !this.ws || this.ws.readyState !== WebSocket.OPEN || !this.synced ? this.setStatus("offline-unsynced") : this.replayingClientUpdateId && this.surfaceReplayStatus && this.setStatus("replaying"), this.schedulePendingPersist();
  }
  setStatus(e) {
    if (this.status !== e) {
      this.status, this.status = e, this.config.onStatusChange?.(e);
      for (const t of this.statusListeners) t(e);
    }
  }
  /**
   * After initial sync, check if the local Y.Doc has content that the
   * server doesn't know about. This happens when content was bootstrapped
   * locally (e.g., initial share seeding) before the WebSocket connected,
   * or when a previous connection failed after bootstrap but before the
   * update could be sent.
   *
   * We compute the diff between what the server sent us and our local state
   * and send it as an update.
   */
  async pushLocalState(e) {
    if (e.serverHasState !== !1) return;
    const t = c.encodeStateAsUpdate(this.ydoc);
    t.length <= 2 || (console.log("[DocumentSync] Pushing local state to server after sync, update size:", t.length), this.enqueuePendingLocalUpdate(t), await this.replayPendingUpdate());
  }
  async replayPendingUpdate() {
    if (!this.replayingClientUpdateId) {
      if (!this.queuedPendingUpdate && this.config.replica && (this.queuedPendingUpdate = this.config.replica.getPendingOutboxUpdate()), !this.queuedPendingUpdate) {
        this.setStatus("connected");
        return;
      }
      if (!this.ws || this.ws.readyState !== WebSocket.OPEN || !this.synced) {
        this.setStatus("offline-unsynced");
        return;
      }
      try {
        const e = this.config.replica && this.config.replica.getState() !== "unavailable" ? this.config.replica.beginOutboxReplay() : Promise.resolve(null), t = this.queuedPendingUpdate;
        this.inflightPendingUpdate = t, this.queuedPendingUpdate = null, this.surfaceReplayStatus = this.status !== "connected";
        let i = await e;
        if (this.config.replica && !i) {
          const d = this.config.replica.getPendingOutboxUpdate();
          if (d) {
            this.inflightPendingUpdate = null, this.queuedPendingUpdate = d, this.surfaceReplayStatus = !1, this.setStatus("offline-unsynced");
            return;
          }
          if (this.config.replica.getState() === "ready" && (await this.config.replica.persistPendingOutboxUpdate(t), i = await this.config.replica.beginOutboxReplay()), !i && this.config.replica.getState() !== "unavailable") {
            this.inflightPendingUpdate = null, this.queuedPendingUpdate = this.config.replica.getPendingOutboxUpdate(), this.surfaceReplayStatus = !1, this.setStatus(this.queuedPendingUpdate ? "offline-unsynced" : "connected");
            return;
          }
        }
        const s = i?.update ?? t, n = i?.batchId ?? (typeof crypto < "u" && typeof crypto.randomUUID == "function" ? crypto.randomUUID() : `pending-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`);
        this.inflightPendingUpdate = s, this.replayingClientUpdateId = n, this.replayingReplicaOutboxIds = i ? i.batchIds : [], this.replayStartedAt ??= Date.now(), this.replayAttemptCount += 1;
        const { encrypted: a, iv: r } = await this.encodeForWire(s);
        this.surfaceReplayStatus ? this.setStatus("replaying") : this.setStatus("connected"), this.send({
          type: "docUpdate",
          encryptedUpdate: a,
          iv: r,
          clientUpdateId: n
        }), this.scheduleReplayAckTimeout(n);
      } catch (e) {
        this.clearReplayAckTimer(), console.error("[DocumentSync] Failed to replay pending local update:", e), this.inflightPendingUpdate && (this.queuedPendingUpdate = this.config.replica ? this.config.replica.getPendingOutboxUpdate() : this.queuedPendingUpdate ? c.mergeUpdates([this.inflightPendingUpdate, this.queuedPendingUpdate]) : this.inflightPendingUpdate, this.inflightPendingUpdate = null), this.replayingClientUpdateId = null, this.replayingReplicaOutboxIds = [], this.surfaceReplayStatus = !1, this.schedulePendingPersist(), this.setStatus("offline-unsynced");
      }
    }
  }
  async handleUpdateAck(e) {
    if (this.lastSeq = Math.max(this.lastSeq, e.sequence), e.clientUpdateId === this.replayingClientUpdateId) {
      if (this.clearReplayAckTimer(), this.config.replica && this.replayingReplicaOutboxIds.length > 0)
        try {
          await this.config.replica.acknowledgeOutbox(
            this.replayingReplicaOutboxIds,
            e.sequence
          );
        } catch (t) {
          console.warn("[DocumentSync] Failed to persist outbox acknowledgement:", t), this.requeueInflightPendingUpdate(), this.setStatus("offline-unsynced");
          return;
        }
      this.config.onOfflineMetric?.({
        metric: "outbox_replay",
        durationMs: this.replayStartedAt === null ? 0 : Date.now() - this.replayStartedAt,
        retryCount: Math.max(0, this.replayAttemptCount - 1),
        rejectionCode: null
      }), this.replayStartedAt = null, this.replayAttemptCount = 0, this.replayingReplicaOutboxIds = [], this.finishReplayingPendingUpdate();
    }
  }
  async handleWriteRejection(e, t) {
    if (!t || t !== this.replayingClientUpdateId)
      return;
    const i = this.config.replica, s = [...this.replayingReplicaOutboxIds];
    if (!(i && s.length === 0)) {
      if (this.clearReplayAckTimer(), this.config.onOfflineMetric?.({
        metric: "outbox_replay",
        durationMs: this.replayStartedAt === null ? 0 : Date.now() - this.replayStartedAt,
        retryCount: Math.max(0, this.replayAttemptCount - 1),
        rejectionCode: e
      }), !D(e)) {
        if (i)
          try {
            await i.recordOutboxError(s, e);
          } catch (n) {
            console.warn("[DocumentSync] Failed to persist retryable outbox error:", n);
          }
        this.requeueInflightPendingUpdate(), this.setStatus("offline-unsynced"), this.ws && this.ws.readyState === WebSocket.OPEN && this.ws.close();
        return;
      }
      i && await i.rejectOutbox(s, e), this.inflightPendingUpdate = null, this.replayingClientUpdateId = null, this.replayingReplicaOutboxIds = [], this.queuedPendingUpdate = i ? i.getPendingOutboxUpdate() : null, this.surfaceReplayStatus = !1, this.replayStartedAt = null, this.replayAttemptCount = 0, this.setStatus("error"), this.notifyPendingWriteWaiters();
    }
  }
  schedulePendingPersist() {
    this.config.onPendingUpdateChange && (this.pendingPersistTimer && clearTimeout(this.pendingPersistTimer), this.pendingPersistTimer = setTimeout(() => {
      this.pendingPersistTimer = null, this.persistLegacyPendingUpdate();
    }, 250));
  }
  flushPendingPersistImmediately() {
    this.config.onPendingUpdateChange && (this.pendingPersistTimer && (clearTimeout(this.pendingPersistTimer), this.pendingPersistTimer = null), this.persistLegacyPendingUpdate());
  }
  async persistLegacyPendingUpdate() {
    if (!this.config.onPendingUpdateChange || this.config.replica && (await this.config.replica.flush(), this.config.replica.getState() !== "unavailable"))
      return;
    const e = this.getMergedPendingUpdate();
    await this.config.onPendingUpdateChange(
      e ? g(e) : null
    );
  }
  handleDisconnect() {
    this.decisionClient.disconnect();
    const e = !this.suppressReconnect;
    this.suppressReconnect = !1, this.clearReplayAckTimer(), this.ws = null, this.synced = !1, this.connecting = !1, this.cursorLagRecordedForConnection = !1, this.requeueInflightPendingUpdate(), this.stopAwarenessCleanup(), this.clearAwarenessThrottle(), this.stopCompactionTimer(), this.awarenessStates.clear(), this.awarenessTimestamps.clear(), this.notifyAwarenessListeners(), this.setStatus(
      this.hasPendingLocalUpdates() ? "offline-unsynced" : "disconnected"
    ), e && this.scheduleReconnect();
  }
  hasPendingLocalUpdates() {
    return !!(this.queuedPendingUpdate || this.inflightPendingUpdate);
  }
  hasUnsettledPendingWrites() {
    return !!(this.queuedPendingUpdate || this.inflightPendingUpdate || this.replayingClientUpdateId);
  }
  notifyPendingWriteWaiters() {
    for (const e of Array.from(this.pendingWriteWaiters))
      e();
  }
  getMergedPendingUpdate() {
    return this.queuedPendingUpdate && this.inflightPendingUpdate ? c.mergeUpdates([
      this.inflightPendingUpdate,
      this.queuedPendingUpdate
    ]) : this.queuedPendingUpdate ?? this.inflightPendingUpdate;
  }
  requeueInflightPendingUpdate() {
    if (this.clearReplayAckTimer(), !this.inflightPendingUpdate) {
      this.replayingReplicaOutboxIds = [], this.surfaceReplayStatus = !1, this.notifyPendingWriteWaiters();
      return;
    }
    this.queuedPendingUpdate = this.config.replica ? this.config.replica.getPendingOutboxUpdate() : this.queuedPendingUpdate ? c.mergeUpdates([this.inflightPendingUpdate, this.queuedPendingUpdate]) : this.inflightPendingUpdate, this.inflightPendingUpdate = null, this.replayingClientUpdateId = null, this.replayingReplicaOutboxIds = [], this.surfaceReplayStatus = !1, this.schedulePendingPersist(), this.notifyPendingWriteWaiters();
  }
  finishReplayingPendingUpdate() {
    if (this.clearReplayAckTimer(), this.inflightPendingUpdate = null, this.replayingClientUpdateId = null, this.config.replica && (this.queuedPendingUpdate = this.config.replica.getPendingOutboxUpdate()), this.surfaceReplayStatus = !1, this.schedulePendingPersist(), this.notifyPendingWriteWaiters(), this.synced && this.queuedPendingUpdate) {
      this.replayPendingUpdate();
      return;
    }
    this.synced && this.setStatus("connected");
  }
  scheduleReconnect() {
    if (this.destroyed || this.reconnectTimer)
      return;
    const t = Math.min(
      h.RECONNECT_BASE_MS * Math.pow(2, this.reconnectAttempt),
      h.RECONNECT_MAX_MS
    ) * (0.5 + Math.random());
    this.reconnectAttempt++, console.log(`[DocumentSync] Reconnecting in ${Math.round(t / 1e3)}s (attempt ${this.reconnectAttempt})`), this.reconnectTimer = setTimeout(() => {
      this.reconnectTimer = null, this.destroyed || this.connect().catch((i) => {
        console.error("[DocumentSync] Reconnect failed:", i);
      });
    }, t);
  }
  cancelReconnect() {
    this.reconnectTimer && (clearTimeout(this.reconnectTimer), this.reconnectTimer = null);
  }
  /**
   * Immediately reconnect, cancelling any pending backoff and resetting attempts.
   * Called externally when the network has been confirmed available (e.g. after
   * the CollabV3 index has reached `synced`). This intentionally tears down any
   * existing socket first: after sleep/wake a WebSocket can remain "open" while
   * the underlying transport is dead, and a forced reconnect is cheaper than
   * waiting for that zombie socket to notice.
   *
   * Falls back to normal backoff on failure.
   */
  reconnectNow() {
    if (!this.destroyed && !(this.ws && this.ws.readyState === WebSocket.CONNECTING)) {
      if (this.cancelReconnect(), this.reconnectAttempt = 0, this.ws) {
        try {
          this.ws.close();
        } catch {
        }
        this.ws = null;
      }
      this.connecting = !1, console.log("[DocumentSync] Network available, attempting immediate reconnect"), this.connect().catch((e) => {
        console.error("[DocumentSync] reconnectNow failed:", e), this.scheduleReconnect();
      });
    }
  }
  scheduleReplayAckTimeout(e) {
    this.clearReplayAckTimer(), this.replayAckTimer = setTimeout(() => {
      if (this.replayAckTimer = null, this.replayingClientUpdateId === e) {
        if (console.warn(
          "[DocumentSync] Timed out waiting for docUpdateAck, forcing reconnect for pending replay",
          {
            roomId: this.getRoomId(),
            clientUpdateId: e,
            hasQueuedPendingUpdate: !!this.queuedPendingUpdate,
            hasInflightPendingUpdate: !!this.inflightPendingUpdate,
            lastSeq: this.lastSeq
          }
        ), this.setStatus("offline-unsynced"), this.ws && this.ws.readyState === WebSocket.OPEN) {
          try {
            this.ws.close();
          } catch (t) {
            console.error("[DocumentSync] Failed to close WebSocket after replay timeout:", t), this.requeueInflightPendingUpdate(), this.synced = !1, this.scheduleReconnect();
          }
          return;
        }
        this.requeueInflightPendingUpdate(), this.synced = !1, this.scheduleReconnect();
      }
    }, h.REPLAY_ACK_TIMEOUT_MS);
  }
  clearReplayAckTimer() {
    this.replayAckTimer && (clearTimeout(this.replayAckTimer), this.replayAckTimer = null);
  }
  /**
   * Start periodic cleanup of stale remote awareness states.
   * Removes entries from users who haven't sent an update recently.
   */
  startAwarenessCleanup() {
    this.stopAwarenessCleanup(), this.awarenessCleanupTimer = setInterval(() => {
      const e = Date.now();
      let t = !1;
      for (const [i, s] of this.awarenessTimestamps)
        e - s > C && (this.awarenessStates.delete(i), this.awarenessTimestamps.delete(i), t = !0);
      t && this.notifyAwarenessListeners();
    }, C / 2);
  }
  stopAwarenessCleanup() {
    this.awarenessCleanupTimer && (clearInterval(this.awarenessCleanupTimer), this.awarenessCleanupTimer = null);
  }
  notifyAwarenessListeners() {
    const e = this.getAwarenessStates();
    for (const t of this.awarenessListeners)
      t(e);
  }
  // --------------------------------------------------------------------------
  // Compaction
  // --------------------------------------------------------------------------
  startCompactionTimer() {
    this.compactionTimer || (this.lastCompactionAttemptAt = Date.now(), this.compactionTimer = setInterval(() => {
      this.maybeCompact();
    }, W));
  }
  stopCompactionTimer() {
    this.compactionTimer && (clearInterval(this.compactionTimer), this.compactionTimer = null);
  }
  /**
   * Lowest scoped member id wins. Awareness misses (a connected member who hasn't sent
   * awareness yet) can briefly cause both candidates to elect themselves;
   * the server tolerates duplicate snapshots (older row is dropped by
   * `DELETE FROM snapshots WHERE replaces_up_to < ?`).
   */
  amCompactionElector() {
    let e = this.memberId;
    for (const t of this.awarenessStates.keys())
      t < e && (e = t);
    return e === this.memberId;
  }
  async maybeCompact() {
    if (this.destroyed || !this.synced || !this.ws || this.ws.readyState !== WebSocket.OPEN || this.pendingCompactionId || this.queuedPendingUpdate || this.inflightPendingUpdate || this.replayingClientUpdateId || this.config.replica?.hasPendingOutbox() || this.skippedUndecodablePayload) return;
    const e = this.lastSeq - this.lastSnapshotSeq;
    if (e <= 0) return;
    const i = Date.now() - this.lastCompactionAttemptAt, s = e >= E, n = e >= v && i >= O;
    !s && !n || this.amCompactionElector() && await this.sendCompactionSnapshot();
  }
  async sendCompactionSnapshot() {
    const e = this.lastSeq, t = c.encodeStateAsUpdate(this.ydoc);
    if (t.byteLength <= 2) {
      console.warn(
        `[DocumentSync] Refusing empty-doc compaction (lastSeq=${e}); leaving server rows untouched`
      );
      return;
    }
    try {
      const { encrypted: i, iv: s } = await this.encodeForWire(t), n = `compact-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
      this.send({
        type: "docCompact",
        encryptedState: i,
        iv: s,
        replacesUpTo: e,
        clientCompactId: n
      }), this.pendingCompactionId = n, this.scheduleCompactionAckTimeout(n), this.lastCompactionAttemptAt = Date.now(), console.log(
        `[DocumentSync] Sent docCompact awaiting ack: replacesUpTo=${e}, snapshotBytes=${t.byteLength}`
      );
    } catch (i) {
      console.warn("[DocumentSync] Failed to send compaction snapshot:", i);
    }
  }
  /**
   * Deliberately replace the server's authoritative state for this room with the
   * CURRENT local Y.Doc, dropping every prior server row -- including rows this
   * client could not decrypt. This is the recovery override for a room whose
   * server state became undecryptable (backup review HIGH finding 1): after a
   * plaintext backup is applied into the otherwise-empty Y.Doc, this promotes it
   * to the sole authoritative snapshot via `docCompact(replacesUpTo = lastSeq)`.
   *
   * Unlike routine compaction it bypasses the `hasUndecodedContent()` guard --
   * that guard protects against ACCIDENTALLY burying unreadable rows, but here
   * discarding them is the whole point. It still refuses an empty snapshot so a
   * blank Y.Doc can never wipe a room. Resolves true once the server acks.
   */
  async forceReplaceServerState(e = 15e3) {
    return this.sendAuthoritativeSnapshot(e, {
      allowEmpty: !1,
      allowUndecoded: !0,
      operation: "force-replace"
    });
  }
  /**
   * Finalize a successfully decoded pre-migration room under server-managed
   * custody. Unlike the disaster-recovery override above, this refuses to bury
   * any payload the client could not decrypt. Empty Y.Docs are allowed because
   * a decoded-but-empty legacy room still needs a current DEK snapshot.
   */
  async finalizeServerManagedState(e = 15e3) {
    return this.sendAuthoritativeSnapshot(e, {
      allowEmpty: !0,
      allowUndecoded: !1,
      operation: "migration-finalize"
    });
  }
  async sendAuthoritativeSnapshot(e, t) {
    if (this.destroyed) throw new Error("Cannot force-replace a destroyed room provider");
    if (!this.synced) throw new Error("Cannot force-replace before the room has synced");
    if (!this.ws || this.ws.readyState !== WebSocket.OPEN)
      throw new Error("Cannot force-replace while the room is disconnected");
    if (!t.allowUndecoded && this.hasUndecodedContent())
      throw new Error("Cannot finalize a room containing content this device could not decrypt");
    await this.waitForPendingWrites(e);
    const i = c.encodeStateAsUpdate(this.ydoc);
    if (!t.allowEmpty && i.byteLength <= 2)
      throw new Error("Refusing to force-replace the room with an empty document");
    const { encrypted: s, iv: n } = await this.encodeForWire(i), a = `${t.operation}-${this.lastSeq}-${this.memberId}-${this.forceReplaceCounter++}`, r = new Promise((d) => {
      const p = setTimeout(() => {
        this.forceReplaceWaiter?.clientCompactId === a && (this.forceReplaceWaiter = null, this.pendingCompactionId === a && (this.pendingCompactionId = null), d(!1));
      }, e);
      this.forceReplaceWaiter = {
        clientCompactId: a,
        resolve: (l) => {
          clearTimeout(p), d(l);
        }
      };
    });
    return this.pendingCompactionId = a, this.send({
      type: "docCompact",
      encryptedState: s,
      iv: n,
      replacesUpTo: this.lastSeq,
      clientCompactId: a
    }), r;
  }
  handleCompactionAck(e) {
    if (e.clientCompactId && e.clientCompactId !== this.pendingCompactionId)
      return;
    this.clearCompactionAckTimer(), this.pendingCompactionId = null, this.lastCompactionAttemptAt = Date.now();
    const t = this.forceReplaceWaiter;
    if (t && (!e.clientCompactId || t.clientCompactId === e.clientCompactId) && (this.forceReplaceWaiter = null, t.resolve(!!e.accepted)), !e.accepted) {
      console.warn(
        `[DocumentSync] Compaction rejected: ${e.error?.code ?? "unknown"} ${e.error?.message ?? ""}`.trim()
      );
      return;
    }
    this.lastSnapshotSeq = Math.max(this.lastSnapshotSeq, e.replacesUpTo), console.log(
      `[DocumentSync] Compaction acknowledged: replacesUpTo=${e.replacesUpTo}${e.deduplicated ? ", deduplicated=true" : ""}`
    );
  }
  scheduleCompactionAckTimeout(e) {
    this.clearCompactionAckTimer(), this.compactionAckTimer = setTimeout(() => {
      this.compactionAckTimer = null, this.pendingCompactionId === e && (this.pendingCompactionId = null, console.warn("[DocumentSync] Compaction acknowledgement timed out; will retry when eligible"));
    }, h.COMPACTION_ACK_TIMEOUT_MS);
  }
  clearCompactionAckTimer() {
    this.compactionAckTimer && (clearTimeout(this.compactionAckTimer), this.compactionAckTimer = null);
  }
}
export {
  h as DocumentSyncProvider
};
//# sourceMappingURL=DocumentSync-DbLa9QKF.js.map
